import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ActorCardCmp_ActorPerson_Fragment = graphql(`
  fragment ActorCardCmp_ActorPerson_Fragment on ActorPerson {
    _id
    __typename
    categoryIds
    index
    isInternal
    typeId
    kind
    thirdPartyId
    contextualRoleIds
    references {
      _id
      typeId
      value
    }
  }
`);

export type ActorCardCmp_ActorPerson = ResultOf<
  typeof ActorCardCmp_ActorPerson_Fragment
>;
